import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { setRemoteResources } from "../i18n";

const SiteContentContext = createContext(null);

export function deepMerge(base, override) {
  if (Array.isArray(override)) return override;
  if (!override || typeof override !== "object") {
    return override === undefined ? base : override;
  }

  const baseObject = base && typeof base === "object" && !Array.isArray(base) ? base : {};
  const out = { ...baseObject };

  Object.entries(override).forEach(([key, value]) => {
    out[key] = deepMerge(baseObject[key], value);
  });

  return out;
}

export function SiteContentProvider({ children }) {
  const [content, setContent] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      try {
        const response = await fetch("/wp-json/arttu-content/v1/site", {
          method: "GET",
          cache: "no-store",
          credentials: "same-origin",
          headers: {
            Accept: "application/json",
          },
        });

        if (!response.ok) return;

        const data = await response.json();
        if (cancelled || !data || typeof data !== "object") return;

        setRemoteResources(data.translations || {});
        setContent(data);
      } catch (error) {
        // WordPress-hallinta on lisäkerros. Jos API ei vastaa,
        // sivusto jatkaa nykyisillä Reactin fallback-sisällöillä.
      }
    };

    load();

    return () => {
      cancelled = true;
    };
  }, []);

  const value = useMemo(() => content, [content]);

  return (
    <SiteContentContext.Provider value={value}>
      {children}
    </SiteContentContext.Provider>
  );
}

export function useSiteContent() {
  return useContext(SiteContentContext);
}
